const dateFormatter = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Los_Angeles',
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
});

export function businessDateISO(value = new Date()) {
    const parts = Object.fromEntries(dateFormatter.formatToParts(value)
        .map(({ type, value: part }) => [type, part]));
    return `${parts.year}-${parts.month.padStart(2, '0')}-${parts.day.padStart(2, '0')}`;
}

export function formatDate(value) {
    if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
        const [year, month, day] = value.split('-').map(Number);
        return `${month}/${day}/${year}`;
    }
    return dateFormatter.format(new Date(value));
}
